import { css } from 'styled-components';

export const marketGuidanceBackgroundStyles = css`
  background: linear-gradient(
      319deg,
      var(--secondary-background-color, var(--c-blue-500)) 16.49%,
      var(--primary-background-color, var(--c-blue-300)) 82.68%
    ),
    linear-gradient(
      to bottom,
      var(--secondary-background-color, var(--c-blue-500)),
      transparent
    ),
    linear-gradient(
      to bottom,
      transparent 23.47%,
      var(--secondary-background-color, var(--c-blue-500)) 86.09%
    );
  background-attachment: fixed;
`;
